import { render, staticRenderFns } from "./Artfolio.vue?vue&type=template&id=06a649c4&"
import script from "./Artfolio.vue?vue&type=script&lang=js&"
export * from "./Artfolio.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports